interface Props {
  size?: number;
  color?: string;
}

export const PauseIcon = (props: Props) => {
  const { size, color } = props;
  return (
    <svg width={size || '24'} height={size || '24'} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M5.74609 3C4.7796 3 3.99609 3.7835 3.99609 4.75V19.25C3.99609 20.2165 4.7796 21 5.74609 21H9.24609C10.2126 21 10.9961 20.2165 10.9961 19.25V4.75C10.9961 3.7835 10.2126 3 9.24609 3H5.74609ZM14.7461 3C13.7796 3 12.9961 3.7835 12.9961 4.75V19.25C12.9961 20.2165 13.7796 21 14.7461 21H18.2461C19.2126 21 19.9961 20.2165 19.9961 19.25V4.75C19.9961 3.7835 19.2126 3 18.2461 3H14.7461Z' fill={color || '#212121'} />
    </svg>
  );
};

export const PlayIcon = (props: Props) => {
  const { size, color } = props;
  return (
    <svg width={size || '24'} height={size || '24'} viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M10.1376 3.38186C8.30432 2.3104 6 3.63266 6 5.7561V22.2448C6 24.3682 8.30431 25.6905 10.1376 24.619L24.8348 16.0294C26.3871 15.1222 26.3872 12.8788 24.8349 11.9716L10.1376 3.38186Z' fill={color || '#212121'} />
    </svg>
  );
};

export const CaretDown = (props: Props) => {
  const { size, color } = props;
  return (
    <svg width={size || '16'} height={size || '16'} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M4.95681 5C4.14912 5 3.67466 5.90803 4.13591 6.57107L6.76854 10.3555C7.36532 11.2134 8.63448 11.2133 9.23126 10.3555L11.8639 6.57106C12.3251 5.90803 11.8507 5 11.043 5H4.95681Z' fill={color || '#212121'} />
    </svg>
  );
};

export const ArrowDown = (props: Props) => {
  const { size, color } = props;
  return (
    <svg width={size || '24'} height={size || '24'} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M19.765 4.20694C20.0649 4.49263 20.0765 4.96736 19.7908 5.26729L12.7241 12.6862C12.5633 12.855 12.3582 12.955 12.1449 12.986C12.098 12.9952 12.0496 13 12 13C11.9506 13 11.9022 12.9952 11.8554 12.9861C11.642 12.9551 11.4368 12.8551 11.2759 12.6862L4.2092 5.26728C3.92351 4.96736 3.93505 4.49262 4.23498 4.20694C4.53491 3.92125 5.00964 3.93279 5.29533 4.23272L12 11L18.7046 4.23272C18.9903 3.93279 19.4651 3.92125 19.765 4.20694Z' fill={color || '#212121'} />
      <path d='M19.765 11.2069C20.0649 11.4926 20.0765 11.9674 19.7908 12.2673L12.7241 19.6862C12.5633 19.855 12.3582 19.955 12.1449 19.986C12.098 19.9952 12.0496 20 12 20C11.9506 20 11.9022 19.9952 11.8554 19.9861C11.642 19.9551 11.4368 19.8551 11.2759 19.6862L4.2092 12.2673C3.92351 11.9674 3.93505 11.4926 4.23498 11.2069C4.53491 10.9213 5.00964 10.9328 5.29533 11.2327L12 18L18.7046 11.2327C18.9903 10.9328 19.4651 10.9213 19.765 11.2069Z' fill={color || '#212121'} />
    </svg>
  );
};

export const ArrowUp = (props: Props) => {
  const { size, color } = props;
  return (
    <svg width={size || '24'} height={size || '24'} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M4.23495 19.7931C3.93502 19.5074 3.92348 19.0326 4.20916 18.7327L11.2759 11.3138C11.4367 11.145 11.6418 11.045 11.855 11.014C11.9019 11.0048 11.9503 11 11.9999 11C12.0494 11 12.0977 11.0048 12.1445 11.0139C12.3579 11.0449 12.5631 11.1449 12.724 11.3138L19.7907 18.7327C20.0764 19.0326 20.0649 19.5074 19.765 19.7931C19.465 20.0787 18.9903 20.0672 18.7046 19.7673L11.9999 13L5.29529 19.7673C5.00961 20.0672 4.53487 20.0787 4.23495 19.7931Z' fill={color || '#212121'} />
      <path d='M4.23495 12.7931C3.93502 12.5074 3.92348 12.0326 4.20916 11.7327L11.2759 4.31379C11.4367 4.14496 11.6418 4.04502 11.855 4.01398C11.9019 4.00481 11.9503 4 11.9999 4C12.0494 4 12.0977 4.00479 12.1445 4.01393C12.3579 4.04491 12.5631 4.14486 12.724 4.31379L19.7907 11.7327C20.0764 12.0326 20.0649 12.5074 19.765 12.7931C19.465 13.0787 18.9903 13.0672 18.7046 12.7673L11.9999 6L5.29529 12.7673C5.00961 13.0672 4.53487 13.0787 4.23495 12.7931Z' fill={color || '#212121'} />
    </svg>
  );
};

export const InfoIcon = (props: Props) => {
  const {
    size,
    color,
  } = props;
  return (
    <svg width={size || '24'} height={size || '24'} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M13 6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6ZM11.25 9.75L11.25 17.25C11.25 17.6642 11.5858 18 12 18C12.4142 18 12.75 17.6642 12.75 17.25L12.75 9.75C12.75 9.33579 12.4142 9 12 9C11.5858 9 11.25 9.33579 11.25 9.75ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5Z' fill={color || '#212121'} />
    </svg>
  );
};
